import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (_route, state): Promise<boolean | UrlTree> => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  // Post-RP8c — try refresh-token redemption before bouncing to /signin.
  // Without this, a hard page-refresh after the 120s access_token expiry
  // sends the operator back to sign-in even though a valid refresh_token
  // is sitting in sessionStorage. refresh() returns false fast when there's
  // no session or no refresh_token, so the truly-unauthenticated cold-boot
  // path pays no extra cost.
  if (await auth.refresh()) {
    return true;
  }

  try {
    sessionStorage.setItem('post_signin_return_url', state.url);
  } catch {
    // sessionStorage unavailable (e.g., headless private mode) — proceed without remembering.
  }
  return router.parseUrl('/signin');
};
